import styled from "styled-components";

export const Container = styled.div`
  cursor: pointer;
  img {
    margin-right: 10px;
  }
`;
